import PocketBase, { RecordModel } from 'pocketbase';

const backendUrl = import.meta.env.VITE_BACKEND_URL;

export const pb = new PocketBase(backendUrl);

// Add request interceptor to log headers
pb.beforeSend = function(url, options) {
    // Add required headers
    options.headers = {
        ...options.headers,
        'Accept': 'application/json',
        'Content-Type': 'application/json'
    };

    return { url, options };
};

// Helper function to get file URL
export const getFileUrl = (record: any, filename: string) => {
    return pb.files.getURL(record, filename);
};

// Type Definitions
export interface Video {
    collectionId: string;
    collectionName: string;
    created: string;
    id: string;
    title: string;
    youtube_id: string;
    order: number;
    updated: string;
}

export interface Cooperative extends RecordModel {
    name: string;
    location: string;
    description: string;
    image: string;
    slug: string;
    membersSpecialName?: string;
    nepaliName?: string;
}

export interface Member extends RecordModel {
    name: string;
    role: string;
    image: string;
    description?: string;
    order: number;
    cooperative: string;
}

export interface Gallery extends RecordModel {
    image: string;
    cooperative: string;
    order?: number;
}

export interface Product {
    id: string;
    name: string;
    description: string;
    image: string;
    price: number;
    cooperative: string;  // This will be the ID of the cooperative
    expand: {
        cooperative: Cooperative;
    };
    created: string;
    updated: string;
}

// API Functions
export const getVideos = async () => {
    try {
        return await pb.collection('videos').getList<Video>(1, 50, {
            sort: 'order'
        });
    } catch (error) {
        console.error('Error fetching videos:', error);
        throw error;
    }
};

export const getProducts = async () => {
    try {
        return await pb.collection('products').getList<Product>(1, 50, {
            expand: 'cooperative'
        });
    } catch (error) {
        console.error('Error fetching products:', error);
        throw error;
    }
};

export const getCooperatives = async () => {
    try {
        return await pb.collection('cooperatives').getList<Cooperative>(1, 50);
    } catch (error) {
        console.error('Error fetching cooperatives:', error);
        throw error;
    }
};
